import { render, staticRenderFns } from "./MyClips.vue?vue&type=template&id=76c207c8&scoped=true&"
import script from "./MyClips.vue?vue&type=script&lang=js&"
export * from "./MyClips.vue?vue&type=script&lang=js&"
import style0 from "./MyClips.vue?vue&type=style&index=0&id=76c207c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c207c8",
  null
  
)

export default component.exports